import { render, staticRenderFns } from "./testingSimonLiveData.vue?vue&type=template&id=15bc068e&"
import script from "./testingSimonLiveData.vue?vue&type=script&lang=js&"
export * from "./testingSimonLiveData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports